import React from 'react';

const CompanyIacNoClosingDates = () => {
  return <div className='mb-2 ml-1 mt-4 text-xs'>No Closing Dates</div>;
};

export default CompanyIacNoClosingDates;
